export const UPLOADING = "UPLOADING"
export const UPLOADED = "UPLOADED"
export const FAILED = "FAILED"
